import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

import Baseball from "../../../../assets/corporative/icon-sports/ic_baseball_selected.png";
import Basketball from "../../../../assets/corporative/icon-sports/ic_basketball_selected.png";
import Boxing from "../../../../assets/corporative/icon-sports/ic_boxing_selected.png";
import Cycling from "../../../../assets/corporative/icon-sports/ic_ciclysm_selected.png";
import Gimnastics from "../../../../assets/corporative/icon-sports/ic_gimnastics_selected.png";
import Golf from "../../../../assets/corporative/icon-sports/ic_golf_selected.png";
import Martial from "../../../../assets/corporative/icon-sports/ic_martial_arts_selected.png";
import Rugby from "../../../../assets/corporative/icon-sports/ic_rugby_selected.png";
import Otros from "../../../../assets/corporative/icon-sports/ic_salud_selected.png";
import Skating from "../../../../assets/corporative/icon-sports/ic_skate_selected.png";
import Soccer from "../../../../assets/corporative/icon-sports/ic_soccer_selected.png";
import Tennis from "../../../../assets/corporative/icon-sports/ic_tennis_selected.png";
import Volleyball from "../../../../assets/corporative/icon-sports/ic_volleyball_selected.png";
import Yoga from "../../../../assets/corporative/icon-sports/ic_yoga_selected.png";
import Running from "../../../../assets/corporative/icon-sports/running.png";
import Swimming from "../../../../assets/corporative/icon-sports/swimming.png";
import Step4Habits from "./step-4-habits";
import { useState } from "react";
import ModalInfo from "../modal-info";

const Step4 = ({ edit, userDetail, setFormData }) => {
  const active_user_sports = userDetail?.funtional_history?.active_sports || [];
  const sleep_habits = userDetail?.funtional_history?.sleep_habits || "";
  const [modal, setModal] = useState(null);
  const objectivesCustomer = [
    {
      name: "Fútbol",
      icon: Soccer,
      code: 1,
    },
    {
      name: "Béisbol",
      icon: Baseball,
      code: 2,
    },
    {
      name: "Básquetbol",
      icon: Basketball,
      code: 3,
    },
    {
      name: "Ciclismo",
      icon: Cycling,
      code: 4,
    },
    {
      name: "Rugby",
      icon: Rugby,
      code: 5,
    },
    {
      name: "Boxeo",
      icon: Boxing,
      code: 6,
    },
    {
      name: "Tennis",
      icon: Tennis,
      code: 7,
    },
    {
      name: "Golf",
      icon: Golf,
      code: 8,
    },
    {
      name: "Patinaje",
      icon: Skating,
      code: 9,
    },
    {
      name: "Voleibol",
      icon: Volleyball,
      code: 10,
    },
    {
      name: "Atletismo",
      icon: Running,
      code: 11,
    },
    {
      name: "Natación",
      icon: Swimming,
      code: 12,
    },
    { name: "Crossfit", icon: Otros, code: 13 },
    {
      name: "Yoga",
      icon: Yoga,
      code: 14,
    },
    {
      name: "Gimnasia",
      icon: Gimnastics,
      code: 15,
    },
    {
      name: "Artes marciales",
      icon: Martial,
      code: 16,
    },
    {
      name: "Otros",
      icon: Otros,
      code: 17,
    },
    {
      name: "No práctico",
      icon: Otros,
      code: 0,
    },
  ];
  function handleModal() {
    setModal(
      <ModalInfo
        onCancel={() => setModal(null)}
        onConfirm={() => setModal(null)}
        loader={false}
      >
        <div className="d-flex justify-content-center p-2">
          <span className="mb-2 label-step px-2">
            <strong>Hábitos y objetivos</strong>
          </span>
        </div>
        <div className="d-flex flex-column" style={{ maxHeight: "50vh" }}>
          <Step4Habits userDetail={userDetail} />
        </div>
      </ModalInfo>
    );
  }
  return (
    <div className=" col-3 px-2 h-100 w-100">
      {modal}
      <div className="d-flex justify-content-start">
        <span className="label-step">
          <strong>4. Historia funcional</strong>
        </span>
      </div>

      <div
        className="pt-2 d-flex flex-column gap-2 w-100"
        style={{ height: "94%" }}
      >
        {/* Parte 1: Objetivos */}
        <div className="step3-card p-2" style={{ minHeight: "12vh" }}>
          {active_user_sports && Object.keys(active_user_sports).length > 0 ? (
            <PerfectScrollbar className="d-flex w-100">
              {Object.entries(active_user_sports).map(([key, item]) => {
                let iconSelected = objectivesCustomer.find(
                  (icon) => icon.code == key
                );
                return (
                  <div
                    key={key}
                    className="d-flex m-1 flex-column align-items-center justify-content-center"
                  >
                    <div className="icon-objective ">
                      <img
                        src={iconSelected.icon}
                        alt={iconSelected.name}
                        className="w-auto p-1"
                      />
                    </div>
                    <div
                      style={{ textAlign: "center", height: "70px" }}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <span
                        className="m-auto"
                        style={{
                          fontSize: "calc(.4rem + .3vw)",
                          lineHeight: "100%",
                        }}
                      >
                        {iconSelected.name}
                      </span>
                    </div>
                  </div>
                );
              })}
            </PerfectScrollbar>
          ) : (
            <div className="d-flex mx-1 my-2 align-items-center">
              <span
                className="text-objective-jus"
                style={{ fontSize: "calc(.4rem + .3vw)" }}
              >
                No practica ningún deporte.
              </span>
            </div>
          )}
        </div>

        {/* Parte 2: Sueño */}
        <div className="d-flex justify-content-between align-items-center flex-grow-1 ">
          <div className="w-100 text-start">
            <span className="label-step">
              <strong>Hábitos de sueño</strong>
            </span>
          </div>
          <div className="w-100">
            <input
              placeholder={sleep_habits}
              type="search"
              className="input_info_athlete_input p-1 p-xxl-2 w-100"
              style={{
                border: "1px solid #b6c1ce",
                borderRadius: "20px",
                textAlign: "center",
              }}
              onChange={(e) => {
                setFormData((prev) => ({
                  ...prev,
                  funtional_history: {
                    ...prev.funtional_history,
                    ["sleep_habits"]: e.target.value,
                  },
                }));
              }}
              readOnly={!edit}
            />
          </div>
        </div>

        {/* Parte 3: Hábitos y objetivos */}

        <div className="step3-card py-1 px-2 flex-grow-1 d-flex flex-column">
          <div className="d-flex justify-content-between p-2">
            <span className="mb-2 label-step px-2">
              <strong>Hábitos y objetivos</strong>
            </span>
            <i className="bi bi-box-arrow-up-right" onClick={handleModal}></i>
          </div>
          <Step4Habits userDetail={userDetail} />
        </div>
      </div>
    </div>
  );
};

export default Step4;
